import UserStore from "./userStore";
import { createContext } from "react";
import { configure } from "mobx";
import CommonStore from "./commonStore";
import TenantStore from "./tenantStore";
import MeetingStore from "./meetingStore";
import PlayerStore from "./playerStore";
import BoardStore from "./boardStore";
import AuthStore from "./authStore";
import SurveyStore from "./surveyStore";
import OfflineStore from "./offlineStore";
import ZwibblerStore from "./zwibblerStore";
import PresentationStore from "./presentationStore";
import ScreensStore from "./screensStore";
import NoteStore from "./noteStore";
import PodiumStore from "./podiumStore";
import GuestStore from "./guestStore";
import ResponsiveStore from "./responsiveStore"
import ArchiveStore from "./archiveStore";
import BroadcastStore from "./broadcastStore";
import caboloStore from "./caboloStore";

configure({ enforceActions: "always" });

export class RootStore {
  commonStore: CommonStore;
  userStore: UserStore;
  tenantStore: TenantStore;
  meetingStore: MeetingStore;
  playerStore: PlayerStore;
  boardStore: BoardStore;
  authStore: AuthStore;
  surveyStore: SurveyStore;
  offlineStore: OfflineStore;
  zwibblerStore: ZwibblerStore;
  presentationStore: PresentationStore;
  screensStore: ScreensStore;
  noteStore: NoteStore;
  podiumStore: PodiumStore;
  guestStore: GuestStore;
  responsiveStore: ResponsiveStore;
  archiveStore: ArchiveStore;
  broadcastStore: BroadcastStore;
  caboloStore: caboloStore

  constructor() {
    this.commonStore = new CommonStore(this);
    this.userStore = new UserStore(this);
    this.tenantStore = new TenantStore(this);
    this.meetingStore = new MeetingStore(this);
    this.playerStore = new PlayerStore(this);
    this.boardStore = new BoardStore(this);
    this.authStore = new AuthStore(this);
    this.surveyStore = new SurveyStore(this);
    this.offlineStore = new OfflineStore(this);
    this.zwibblerStore = new ZwibblerStore(this);
    this.presentationStore = new PresentationStore(this);
    this.screensStore = new ScreensStore(this);
    this.noteStore = new NoteStore(this);
    this.podiumStore = new PodiumStore(this);
    this.guestStore = new GuestStore(this);
    this.responsiveStore = new ResponsiveStore(this);
    this.archiveStore = new ArchiveStore(this);
    this.broadcastStore = new BroadcastStore(this);
    this.caboloStore = new caboloStore(this);
  }
}

export const RootStoreContext = createContext(new RootStore());
